import { gql } from "@apollo/client";

export const CREATOR_CARD_CLIPS = gql`
  query CreatorCardClips($cardId: String!) {
    creatorCardClips(cardId: $cardId) {
      _id
      clipTitle
      clipLinkHLS
      clipLink
      clipImageThumb
      clipImageSource
      username
      shareId
      views
      user {
        _id
        avatar
        userGroup {
          type
        }
        discord {
          username
          id
          avatar
        }
        scope
        rank
        username
      }
    }
  }
`;
